import React, { useMemo } from 'react'
import './AboutBanner.css'
import RichTextContent, { CmsText } from '../../../RichTextContent/RichTextContent'
import { useAboutSection } from '../../../../context/AboutPageContext'
import { resolveMediaUrl } from '../../../../utils/resolveMediaUrl'

const AboutBanner = () => {
  const { section, loading } = useAboutSection('about-banner')

  const bgSrc = useMemo(() => {
    const url = section?.media?.primary?.url
    return url ? resolveMediaUrl(url) : ''
  }, [section])

  if (loading || !section?.fields) return null

  const fields = section.fields

  return (
    <section className="about-banner">
      <div className="about-banner-bg">
        {bgSrc ? <img src={bgSrc} alt="" /> : null}
        <div className="about-banner-overlay"></div>
      </div>

      <div className="about-banner-content">
        {fields.subtitle ? (
          <CmsText
            content={fields.subtitle}
            as="p"
            className="about-banner-subtitle"
          />
        ) : null}

        {fields.title ? (
          <CmsText
            content={fields.title}
            as="h1"
            className="about-banner-title"
          />
        ) : null}

        {fields.description ? (
          <RichTextContent
            content={fields.description}
            className="about-banner-description"
          />
        ) : null}
      </div>
    </section>
  )
}

export default AboutBanner
